import useMediaQuery from "@material-ui/core/useMediaQuery";
import { ReactNode } from "react";

interface DetailsSectionTitleProps {
    title?: string;
	children?: ReactNode;
	hideMobile?: boolean;
}

const DetailsSectionTitle: React.FC<DetailsSectionTitleProps> = ({ title, children, hideMobile = false }) => {
	const isMobile = useMediaQuery('(max-width: 800px)');

	if (hideMobile && isMobile) return null
	return <div className='section-title'>{title || children}</div>
}

export default DetailsSectionTitle;